import axios from 'axios'

export default {
    namespaced: true,

    state: {
        authenticated: sessionStorage.getItem('authenticated') || false,
        studentRecord: JSON.parse(sessionStorage.getItem('studentRecord')) || null,
        schoolName: process.env.VUE_APP_THEME_SCHOOL, 
        credentials: {},
    },

    getters: {
        getAuthenticated (state) {
            return state.authenticated
        },
        getStudentRecord(state){
            return state.studentRecord
        },
        getSchoolName (state) {
            return state.schoolName
        },
        getCredentials(state){
            return state.credentials
        }
    },

    mutations: {
        setAuthenticated (state, value) {
            state.authenticated = value
        },
        setStudentRecord(state, value){
            state.studentRecord = value
        },
        setCredentials(state, value){
            state.credentials = value
        }
    },

    actions: {

        getCSRFCookie(){
            return axios.get('/sanctum/csrf-cookie');
        },
        signIn ({ getters }){ 
            console.log("authenticating login credentials");
            return axios.post('/api/login-student', getters.getCredentials);
        },

        async signOut({commit}){                       
            await axios.post('/logout');
            return commit('setAuthenticated', false); 
        },
    }
}